<template>
  <div
    :class="errorMessage ? 'error' : ''"
    class="portal-input"
  >
    <div class="portal-input-section">
      <input
        :value="value"
        :placeholder="label"
        :type="type"
        :disabled="disabled"
        @input="input($event.target.value)"
      >
      <div
        v-if="slotFilled"
        class="suffix"
        :class="{ 'clickable': suffixClickable }"
        @click="suffixClicked()"
      >
        <slot />
      </div>
    </div>

    <div class="error-message">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: { type: String, default: null },
    value: { type: String, default: '' },
    error: { type: String, default: null },
    type: { type: String, default: 'text' },
    suffixClickable: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data: () => ({
    typing: null,
    errorMessage: null,
  }),
  computed: {
    slotFilled() {
      return this.$scopedSlots.default;
    },
  },
  watch: {
    error() {
      if (!this.error || !this.typing || this.errorMessage) {
        this.errorMessage = this.error;
      }
    },
  },
  methods: {
    input(value) {
      clearTimeout(this.timeout);
      this.typing = true;
      this.timeout = setTimeout(() => {
        this.typing = false;
        this.errorMessage = this.error;
      }, 300);

      this.$emit('input', value);
    },
    suffixClicked() {
      this.$emit('suffix-clicked');
    },
  },
};
</script>

<style scoped>
.portal-input {
  position: relative;
}
.portal-input-section {
  position: relative;
}
input {
  color: #263238;
  width: 100%;
  max-width: 100%;
  padding: 10px 10px 10px 5px;
  box-sizing: border-box;
  margin-bottom: 20px;
  border: 1px solid #dcdcdc;
  border-radius: 4px;
  transition: border 0.2s ease-in-out;
}

.dark-theme .portal-input-section input {
  background-color: var(--webeo-background-2) !important;
  color: var(--webeo-white) !important;
}
.portal-input.error input {
  border: 1px solid red;
}
input:hover {
  border: 1px solid #bdbdbd;
}
input:focus {
  border: 1px solid var(--webeo-secondary);
  outline: none;
}
.suffix {
  position: absolute;
  right: 0;
  bottom: 22px;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #b5b1af;
  user-select: none;
  min-height: 40px;
  min-width: 40px;
}
.suffix.clickable:hover {
  cursor: pointer;
  color: #a0a0a0;
}
.error-message {
  font-size: 11px;
  color: red;
  position: absolute;
  bottom: 2px;
  opacity: 0;
  transition: 0.3s opacity;
}
.portal-input.error .error-message {
  opacity: 1;
}
input[type="password"]::-ms-reveal,
input[type="password"]::-ms-clear {
  display: none;
}
</style>
